export { default } from './MerchantBadge'
